import { render, staticRenderFns } from "./PayslipSidebarContent.vue?vue&type=template&id=0be04203&"
import script from "./PayslipSidebarContent.vue?vue&type=script&lang=js&"
export * from "./PayslipSidebarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports